var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.45 66.28A20.21 20.21 0 0 1 81.99 52.8c3.1-.9 6.66-1.05 9.61.4a7 7 0 0 1 4.12 6.85c-.2 2.82-2.15 5.19-5.08 5.16-3.23 0-5.96-2.6-7.43-5.27a14.4 14.4 0 0 1-1.4-9.62 16.43 16.43 0 0 1 4.98-8.61 20.49 20.49 0 0 1 8.91-4.87c3-.74 6.39-.8 9.19.62a9.23 9.23 0 0 1 1.89 1.26c.34.3-.07.9-.42.58-4.73-4.08-12.12-2.1-16.77 1.08a17.27 17.27 0 0 0-6.19 7.24 14.12 14.12 0 0 0-.76 8.98c.72 2.94 2.56 5.86 5.36 7.23 1.34.65 2.93.95 4.34.36a4.31 4.31 0 0 0 2.36-2.68 6.21 6.21 0 0 0-2.36-7.04c-2.5-1.75-5.81-1.92-8.72-1.34a19.46 19.46 0 0 0-13.77 11.26c-.3.7-.54 1.41-.75 2.15-.13.44-.8.18-.67-.25l.02-.01z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3 51.18a18.77 18.77 0 0 1 26.54.68 18.77 18.77 0 0 1-14.1 31.7 18.76 18.76 0 0 1-13.12-5.84 18.76 18.76 0 0 1-5.16-13.41 18.76 18.76 0 0 1 5.84-13.13z",
    fill: "#F5C625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.84 83.8a18.77 18.77 0 1 1 25.86 27.22 18.77 18.77 0 0 1-25.86-27.21z",
    fill: "#3063E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m106.75 66.81-16.26 17.2a6.94 6.94 0 0 0 .27 9.81l17.2 16.26a6.94 6.94 0 0 0 9.81-.27l16.26-17.2a6.94 6.94 0 0 0-.27-9.81l-17.2-16.26a6.94 6.94 0 0 0-9.81.27z",
    fill: "#CA58FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m174.13 96.74 50.63-16.23.03.08c8.86 27.8-6.7 57.96-34.5 66.83-27.8 8.88-57.98-6.7-66.84-34.5l50.68-16.18z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m172.68 24.9-25.37 50.47a16.67 16.67 0 1 0 29.8 14.98l25.37-50.47a16.68 16.68 0 1 0-29.8-14.98z",
    fill: "#138849"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m121.36 30.68 32.74-2.85a33.03 33.03 0 0 1-29.88 35.6l-2.86-32.75z",
    fill: "#CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralError);
export default __webpack_public_path__ + "static/media/general-error.cb21f7766751d4ebd53e1ef88d44f22e.svg";
export { ForwardRef as ReactComponent };